import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import sessionReducer, { sessionExpired } from './sessionSlice';
import { configureHttpClient } from '../core/http/client';

export const store = configureStore({
  reducer: {
    session: sessionReducer,
  },
});

// Wire the HTTP client to the Redux session lifecycle. Tokens themselves are
// never stored in Redux — tokenStorage holds them; the store only tracks
// session status and the tenant-scoped base data.
configureHttpClient({
  onSessionExpired: () => {
    store.dispatch(sessionExpired());
  },
  notify: (message, kind) => {
    try {
      if (kind === 'error') toast.error(message);
      else toast.success(message);
    } catch {
      // Toast container may not be mounted (e.g. in some test environments).
    }
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
